import {AfterViewChecked, Component} from "@angular/core";
import {BaseComponent} from "../base-component";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";

@Component({
  template: ''
})
export abstract class PaginatedBaseComponent extends BaseComponent implements AfterViewChecked {

  protected constructor(protected toasterService: ToastrService, protected route: ActivatedRoute) {
    super(toasterService);
  }

  /// This method is necessary to set the active page in the pagination control.
  /// If the ngModel changes through a promise it isn't getting picked up by the pagination control.
  paginationUpdated(pageNumber: number) {
    document.querySelectorAll('pagination .page-link').forEach((element) => {
      if (element.textContent === pageNumber.toString()) {
        element.parentElement.classList.add('active');
      } else {
        element.parentElement.classList.remove('active');
      }
    });
  }

  ngAfterViewChecked(): void {
    this.route.queryParams.subscribe(params => {
      if(params.pageNumber) {
        this.paginationUpdated(params.pageNumber);
      }
    });
  }
}
